import { APP_INITIALIZER, Provider } from '@angular/core';
import { TranslateService } from './translate.service';

export function provideI18n(preloadLibraries: string[] = []): Provider[] {
  return [
    {
      provide: APP_INITIALIZER,
      useFactory: (translateService: TranslateService) => () =>
        translateService.initialize(preloadLibraries),
      deps: [TranslateService],
      multi: true,
    },
  ];
}
